import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import './DatapointsExportModalFooter.scss';

function DatapointsExportModalFooter({ applyDatapoints, cancelDatapoints }) {
  return (
    <div className="exportModal__footer datapointsExportModal__footer">
      <Button
        type="button"
        onClick={cancelDatapoints}
        buttonConfig={{
          label: 'Cancel',
          type: 'link',
          size: 'sm',
          e2eName: 'export-modal-cancel',
          iconOnly: true,
        }}
        iconConfig={{
          size: 'xs',
          position: 'before',
        }}
      />
      <Button
        type="button"
        onClick={applyDatapoints}
        buttonConfig={{
          label: 'Add datapoints',
          type: 'tertiary',
          size: 'sm',
          e2eName: 'export-modal-apply',
          iconOnly: true,
        }}
        iconConfig={{
          size: 'xs',
          name: 'chevron-right',
        }}
      />
    </div>
  );
}

DatapointsExportModalFooter.propTypes = {
  applyDatapoints: PropTypes.func.isRequired,
  cancelDatapoints: PropTypes.func.isRequired,
};

export default DatapointsExportModalFooter;
